import { useLoaderData, useNavigate } from "react-router-dom";
import { useState } from "react";
import FormSerie from "./FormSerie";
import { getSerieUpdate } from "../../api/Get";
import { putSerie } from "../../api/Put";
import { message } from "antd";
import GenreSerie from "./GenreSerie";

const putSerieLoader = async ({ params }) => {
  const details = await getSerieUpdate(params.idSerie);
  return details;
};

const PutSerie = () => {
  const navigate = useNavigate();
  const { serieDetails } = useLoaderData();

  const [messageApi, contextHolder] = message.useMessage();

  const [errorMsg, setErrorMsg] = useState("");

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Série mise à jour",
    });
  };

  const onFinish = async (values) => {
    console.log(serieDetails.serie);
    if (serieDetails.id) {
      console.log(values);
      const res = await putSerie({ ...values, idSerie: serieDetails.id });
      console.log(res);
      if (res.error) setErrorMsg(res.error);
      else success();
    }
  };

  return (
    <>
      {contextHolder}
      <FormSerie
        title={"Mettre à jour une série"}
        type={"update"}
        onFinish={onFinish}
        initialValues={{
          serieState: serieDetails.statut || "admin",
          collectionName: serieDetails.CollectionName || null,
          serieName: serieDetails.name,
          uidSerie: serieDetails.uid,
          author: serieDetails.author,
          illustrator: serieDetails.illustrator,
          legalLines: serieDetails.credits,
          age: serieDetails.age,
        }}
        collections={[{ name: serieDetails.CollectionName }]}
        errorMsg={errorMsg}
        goBack={() => {
          navigate(-1);
        }}
        imgDetails={[
          ...serieDetails.ImgTypes.map((i) => {
            return {
              url: `https://newbrand.s3.eu-west-3.amazonaws.com/series/${serieDetails.uid}/couvertures/${i.SerieImg.url}`,
              name: i.SerieImg.url,
            };
          }),
          ...(serieDetails.imgHeader !== null
            ? [
                {
                  url: `https://newbrand.s3.eu-west-3.amazonaws.com/series/${serieDetails.uid}/headers/${serieDetails.imgHeader}`,
                  name: serieDetails.imgHeader,
                },
              ]
            : []),
        ]}
        accessEps={() => {
          navigate(`/serie/${serieDetails.id}/details/`, {
            state: { serie: serieDetails },
          });
        }}
        accessCollection={() => {
          navigate(`/collection/details/${serieDetails.Collection.uid}`);
        }}
      />
      <GenreSerie
        serieGenres={serieDetails.Genres.map((g) => g.name)}
        idSerie={serieDetails.id}
        onSuccess={success}
      />
    </>
  );
};

export { PutSerie, putSerieLoader };
